var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgM10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7628 1.5H7.23781C6.45781 1.5 5.82031 2.13 5.82031 2.91V3.615C5.82031 4.395 6.45031 5.025 7.23031 5.025H10.7628C11.5428 5.025 12.1728 4.395 12.1728 3.615V2.91C12.1803 2.13 11.5428 1.5 10.7628 1.5Z",
    fill: "#0F55DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9312 3.61511C12.9312 4.80761 11.9563 5.78261 10.7638 5.78261H7.23875C6.04625 5.78261 5.07125 4.80761 5.07125 3.61511C5.07125 3.19511 4.62125 2.93261 4.24625 3.12761C3.18875 3.69011 2.46875 4.80761 2.46875 6.09011V13.1476C2.46875 14.9926 3.97625 16.5001 5.82125 16.5001H12.1812C14.0262 16.5001 15.5337 14.9926 15.5337 13.1476V6.09011C15.5337 4.80761 14.8138 3.69011 13.7563 3.12761C13.3813 2.93261 12.9312 3.19511 12.9312 3.61511ZM9.28625 12.7126H6.00125C5.69375 12.7126 5.43875 12.4576 5.43875 12.1501C5.43875 11.8426 5.69375 11.5876 6.00125 11.5876H9.28625C9.59375 11.5876 9.84875 11.8426 9.84875 12.1501C9.84875 12.4576 9.59375 12.7126 9.28625 12.7126ZM11.2513 9.71261H6.00125C5.69375 9.71261 5.43875 9.45761 5.43875 9.15011C5.43875 8.84261 5.69375 8.58761 6.00125 8.58761H11.2513C11.5588 8.58761 11.8138 8.84261 11.8138 9.15011C11.8138 9.45761 11.5588 9.71261 11.2513 9.71261Z",
    fill: "#0F55DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM10);
export default __webpack_public_path__ + "static/media/m_10.8a937fbfdf06accfc309d8682edb1921.svg";
export { ForwardRef as ReactComponent };